import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  open: false,
  anchorOrigin: { vertical: "bottom", horizontal: "left" },
  autoHideDuration: 5000,
  message: "",
};

const snackbarSlice = createSlice({
  name: "snackbar",
  initialState,
  reducers: {
    updateSnackbar(state, action) {
      state.open = true;
      state.message = action.payload.message;
    },
    closeSnackbar(state) {
      state.open = false;
      state.message = "";
    },
  },
});

export const { updateSnackbar, closeSnackbar } = snackbarSlice.actions;
export default snackbarSlice.reducer;
